<template>
  <v-container grid-list-xl class="ma-0 pa-5" v-if="current_instansi">
    <m-breadcrum :items="bread"></m-breadcrum>
    <div>
      <v-row wrap>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0 py-0" align="center">
          <div class="grey lighten-2 ma-1 py-2">
            <a href="https://play.google.com/store/apps/details?id=id.simpkb.app" target="_blank">
              <v-img
                max-width="750px"
                :lazy-src="
                  $vuetify.breakpoint.smAndUp
                    ? 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb.png'
                    : 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb-mobile-version.png'
                "
                :src="
                  $vuetify.breakpoint.smAndUp
                    ? 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb.png'
                    : 'https://cdn.siap.id/s3/simpkb/asset%20img/banner-info/Leaderboard-iklan-simpkb-mobile-version.png'
                "
              ></v-img>
            </a>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mt-2 pt-2 mb-0 pb-0">
          <v-alert border="top" colored-border type="info" dismissible elevation="2" v-for="info in informasis" :key="info.id">
            <p class="font-weight-bold my-0 py-0">{{ info.judul }}</p>
            <div class="my-0 py-0" v-html="info.informasi"></div>
          </v-alert>
        </v-col>
        <!-- <v-col cols="12" class="my-0 py-0">
          <m-alert class="py-3" icon="mdi-bell-alert" color="orange" show v-if="kelasku.length > 0 && kelasku[0].is_complete">
            <template>
              <span class="black--text font-weight-bold mr-2">Pengingat!</span>
              <span class="black--text">
                <div v-html="informasiTryout"></div>
              </span>
            </template>
          </m-alert>
        </v-col> -->

        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0"> <span class="title black--text">Fasilitasi Kegiatan</span> </v-col>

        <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="kelasku.length == 0 && current_instansi.is_tutup">
          <m-alert class="py-3" icon="mdi-bell-alert" color="orange" show>
            <template>
              <span class="black--text  mr-2">Pendaftaran Guru Belajar dan Berbagi seri Belajar Mandiri Calon Guru ASN PPPK Mapel Umum telah ditutup.</span>
            </template>
          </m-alert>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-else-if="kelasku.length == 0 && !current_instansi.is_tutup">
          <CourseCard
            :title="defPppk.keterangan"
            :isangkatan="false"
            icon="mdi-account"
            :item="defPppk"
            type="pilihJenis"
            :isSyarat="true"
            :syarats="syaratPendaftaran"
            :isModeKelas="true"
            @toEnroll="pilihJadwal()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-else>
          <CardMapel :isUbahMapel="isUbahMapel" :title="mapelTerpilih.nama" :item="mapelTerpilih" @ubahMapel="ubahMapel()" />
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="kelas in kelasku" :key="kelas.index">
          <CourseCard
            :title="kelas.kelas.nama"
            buttonText="Lihat Fasilitasi"
            :serverTime="kelas.server_time"
            :isJadwalUlang="false"
            type="enroll"
            :item="kelas"
            icon="mdi-account"
            @reload="getKelasku"
            @ubahMapel="ubahMapel"
            @toPerawatan="infoPerawatan"
          />
        </v-col>
      </v-row>
      <br />
      <v-row v-if="kelasku.length > 0">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0">
          <span class="title black--text">Pendaftaran dan Penjadwalan Tryout</span>
        </v-col>

        <template v-if="tryoutku.length > 0 && kelasku.length > 0 && kelasku[0].is_complete == 1">
          <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="tryout in tryoutku" :key="tryout.index">
            <TryoutCard
              :title="tryout.kelas.nama"
              buttonText="Lihat Fasilitasi"
              :serverTime="tryout.server_time"
              :isJadwalUlang="false"
              :isRilis="tryout.kelas.is_rilis == 1 ? true : false"
              type="enroll"
              :item="tryout"
              icon="mdi-account"
              @reload="getKelasku"
              @ubahMapel="ubahMapel"
              @updateNilai="updateNilai"
            />
          </v-col>
        </template>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-if="showDaftarTryout && kelasku.length > 0 && kelasku[0].is_complete == 1">
          <TryoutCard type="pilih" :mapel="mapelTerpilih.nama" :tahap="tahapTryout" :syarats="syaratTryout" @toEnroll="daftarTryout" />
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="kelasku.length > 0 && kelasku[0].is_complete == 0">
          <m-alert show color="warning">
            <template>
              <span class="black--text"
                >Anda berkesempatan untuk mengikuti <i>tryout</i>, dengan syarat harus <strong>menyelesaikan tahap fasilitasi</strong>. <i>Tryout</i> yang akan Anda ikuti sesuai
                dengan mata pelajaran pada tahap fasilitasi. <strong>Pastikan mata pelajaran yang Anda ikuti sudah sesuai</strong>.</span
              >
              <m-button class="my-1 mx-2" icon="mdi-refresh" color="primary" action="reloadKelasku" @reloadKelasku="getKelasku" small text-button="Muat Ulang"></m-button>
            </template>
          </m-alert>
        </v-col>
      </v-row>
    </div>
    <PilihKelasDialog ref="dlgKelas" />
    <PilihTryoutDialog ref="dlgTryout" />
    <PerawatanDialog ref="dlgPerawatan" />
    <AjuanDialog ref="dlgAjuan" />
  </v-container>
</template>

<script>
import PilihKelasDialog from "../../kelas/components/PendaftaranPppkDialog";
import PilihTryoutDialog from "../../kelas/components/PendaftaranTryoutPppkDialog";
import PerawatanDialog from "../../home/components/InfoPerawatan";
import AjuanDialog from "../../kelas/components/AjuanTryoutDialog";
export default {
  components: {
    CourseCard: () => import("@/components/CoursePppkCard"),
    TryoutCard: () => import("@/components/CourseTryoutCard"),
    CourseComplete: () => import("@/components/CourseComplete"),
    CardMapel: () => import("../../home/components/CardMapel"),
    PilihKelasDialog,
    PilihTryoutDialog,
    PerawatanDialog,
    AjuanDialog
  },

  data() {
    return {
      statusKetuntasan: true,
      syaratPendaftaran: [],
      defPppk: {
        id: 11,
        instansi_id: 5,
        keterangan: "Pendaftaran Pembelajaran",
        is_kuota: 0,
        is_show_course: 1,
        is_pindah: 1,
        is_selfenrol: 1,
        agreement: null,
        cover: "https://cdn.siap.id/s3/simpkb/asset img/guru-praktik-baik/seri-pppk.png",
        enrollment_id: 3,
        mode_id: 1,
        is_daring: 1,
        jml_kelas_available: 1,
        tanggal_mulai: "2021-02-01",
        tanggal_selesai: "2021-02-31"
      },
      mapelTerpilih: null,
      kelasku: [],
      tryoutku: [],
      tahap1: null,
      tahap2: null,
      jadwalTryouts: [],
      rsyncCount: 1,
      t: false,
      informasis: []
    };
  },
  mounted() {
    this.rsyncCount = 1;
    this.getKelasku();
    this.loadInformasi();
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-home",
          title: "Pilihan Seri",
          to: { name: "instansi.pilih" }
        },
        {
          icon: "mdi-edit",
          title: this.current_instansi ? this.current_instansi.nama : "-"
        }
      ];
    },
    //@vuese
    // pengecekan apakah masih bisa ubah atau pilih mapel kembali
    isUbahMapel() {
      // tidak bisa ubah mapel karena sudah ubah mapel 1x
      if (!this.current_user.is_daftar_p3k_umum && !this.current_user.is_daftar_p3k_kejuruan && this.tryoutku.length == 0) {
        return 1;
      }
      // tidak bisa ubah mapel karena daftar tryout
      else if (!this.current_user.is_daftar_p3k_umum && !this.current_user.is_daftar_p3k_kejuruan && this.tryoutku.length > 0) {
        return 2;
      }
      // bisa ubah mapel
      else {
        return 3;
      }
    },
    //@vuese
    // list syarat tryout di card tryout
    syaratTryout() {
      return [
        {
          id: 1,
          nama_syarat: "Status",
          keterangan: "Sudah menyelesaikan Fasilitasi",
          is_aktif: 1,
          status: this.statusKetuntasan
        }
      ];
    },
    // @vuese
    // menampilkan card pendaftaran jika kondisi terpenuhi
    showDaftarTryout() {
      // jika belum terdaftar di semua tryout
      if (this.tryoutku.length == 0) {
        return true;
        // jika sudah daftar di tryout tahap 1 dan jadwal sudah lewat
      } else if (this.tryoutku.length == 1 && this.tryoutku[0].kategori_id == 2) {
        var tryout1 = this.tryoutku[0];
        // jika sudah ada jadwalnya dan sudah dapat waktu
        if (tryout1.waktu) {
          var waktuSelesai = this.$tools.combineWaktu(tryout1.waktu.tanggal, tryout1.waktu.sesi.waktu_selesai);
          if (this.$tools.parseIsAfter(tryout1.server_time, waktuSelesai)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      // jika tryout sudah 2x, tryout umum semua dan mapel exist mapel kejuruan
      // else if (this.tryoutku.length == 2 && !this.tryoutku[2].kelas.mapel.is_kejuruan && this.kelasku[0].is_complete && this.kelasku[0].kelas.mapel.is_kejuruan) {
      //   return true;
      // }
      else if (this.tryoutku.length == 2 && !this.tryoutku[0].kelas.mapel.is_kejuruan && this.kelasku[0].kelas.mapel.is_kejuruan) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // cek tahap tryout
    tahapTryout() {
      // jika belum terdaftar di semua tryout
      if (this.tryoutku.length == 0) {
        return 1;
        // jika sudah daftar di tryout tahap 1 dan jadwal sudah lewat
      } else if (this.tryoutku.length == 2 && this.kelasku[0].kelas.mapel.is_kejuruan) {
        return 1;
        // jika sudah daftar di tryout tahap 1 dan jadwal sudah lewat
      } else {
        return 2;
      }
    },
    //@vuese
    // informasi terkait tryout
    informasiTryout() {
      //sudah tuntas fasilitasi dan belum melakukan pendaftaran tryout
      if (this.tryoutku.length == 0 && this.kelasku.length > 0 && this.kelasku[0].is_complete) {
        return "Silakan melakukan pendaftaran <i>tryout</i>";
      }
      //sudah daftar tahap 1 dan sudah dapat jadwal
      else if (this.tryoutku.length == 1 && this.tryoutku[0].waktu) {
        var waktuSelesaiTahap1 = this.$tools.combineWaktu(this.tryoutku[0].waktu.tanggal, this.tryoutku[0].waktu.sesi.waktu_selesai);
        // tryout tahap 1 selesai
        if (this.$tools.parseIsAfter(this.tryoutku[0].server_time, waktuSelesaiTahap1)) {
          return "Jadwal Tryout " + this.mapelTerpilih.nama + " telah Selesai. Jika bersedia, Anda bisa mengikuti tryout paket lain (jika masih tersedia kuota)";
          // tryout sedang berlangsung
        } else {
          if (this.tryoutku[0].kelas.is_rilis == 1) {
            var info =
              "Anda sudah terdaftar pada <strong><i>tryout</i></strong> " +
              this.mapelTerpilih.nama +
              ", hari <strong>" +
              this.$tools.toD(this.tryoutku[0].waktu.tanggal) +
              " pukul " +
              this.$tools.toST(this.tryoutku[0].waktu.sesi.waktu_mulai) +
              "-" +
              this.$tools.toST(this.tryoutku[0].waktu.sesi.waktu_selesai) +
              " WIB </strong>";
            return info;
          } else {
            return "Jadwal Anda sedang kami siapkan";
          }
        }
      }
      //sudah daftar tahap 2 dan sudah dapat jadwal
      else if (this.tryoutku.length == 2 && this.tryoutku[1].waktu) {
        var waktuSelesaiTahap2 = this.$tools.combineWaktu(this.tryoutku[1].waktu.tanggal, this.tryoutku[1].waktu.sesi.waktu_selesai);
        if (this.$tools.parseIsAfter(this.tryoutku[0].server_time, waktuSelesaiTahap2)) {
          return "Jadwal Tryout telah Selesai Anda ikuti.";
          // tryout sedang berlangsung
        } else {
          if (this.tryoutku[0].kelas.is_rilis == 1) {
            var info2 =
              "Anda sudah terdaftar pada <strong><i>tryout</i></strong> " +
              this.mapelTerpilih.nama +
              ", hari <strong>" +
              this.$tools.toD(this.tryoutku[1].waktu.tanggal) +
              " pukul " +
              this.$tools.toST(this.tryoutku[1].waktu.sesi.waktu_mulai) +
              " - " +
              this.$tools.toST(this.tryoutku[1].waktu.sesi.waktu_selesai) +
              " WIB </strong>";
            return info2;
          } else {
            return "Jadwal Anda sedang kami siapkan";
          }
        }
      }
      // selain kondisi diatas
      else {
        return "Jadwal <i>tryout</i> Anda sedang kami proses dalam kurun waktu maksimal 1x24 jam, silakan cek secara berkala untuk melihat informasi terbaru.";
      }
    }
  },
  methods: {
    //@vuese
    // menampilka daftar informasi umum
    loadInformasi() {
      return this.$store
        .dispatch("instansi/getInformasi", this.instansi_id)
        .then(res => {
          this.informasis = res;
        })
        .catch(e => e);
    },
    //@vuese
    // pengecekan syarat, jika syarat ada yg tidak terpenuhi panggil method rsyncAkunSimpkb
    cekSyaratPendaftaran() {
      return this.$store
        .dispatch("user/cekSyaratPppk", {})
        .then(res => {
          this.syaratPendaftaran = res;
          // cek status pendaftaranntya
          var statusSyarat = [];
          res.forEach(syarat => {
            statusSyarat.push(syarat.status);
          });
          // jika tidak memenuhi syarat dan counter sync ==1, panggil api rsync akun simpkb
          if (statusSyarat.includes(false) && this.rsyncCount == 1) {
            this.rsyncAkunSimpkb();
          }
        })
        .catch(e => e);
    },
    //@vuese
    // cek status singkronisasi akun simpkb, untuk pengecekan syarat
    rsyncAkunSimpkb() {
      return this.$store
        .dispatch("user/syncAkun", {})
        .then(() => {
          this.rsyncCount = 0;
          this.cekSyaratPendaftaran();
        })
        .catch(e => e);
    },

    updateNilai(kelas_enrol_id) {
      return this.$store
        .dispatch("kelas/nilaiTryout", {
          kelas_enrol_id: kelas_enrol_id
        })
        .then(res => {
          if (res.error) {
            this.$error("Proses pengambilan nilai gagal");
          } else {
            this.$info("Nilai Tryout Anda : " + res);
          }
          this.getKelasku();
        })
        .catch(e => e);
    },
    //@vuese
    // tampilkan daftar kelas sesuai kategori, jika kelas belum sync panggil method getKelasku secara berkala
    getKelasku() {
      return this.$store
        .dispatch("kelas/getKelaskuPppk", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          if (res.length == 0) {
            this.cekSyaratPendaftaran();
          } else {
            this.kelasku = res.filter(res => res.kategori_id == 1);
            this.tryoutku = res.filter(res => res.kategori_id == 2);
            this.mapelTerpilih = res.filter(res => res.kategori_id == 1)[0].kelas.mapel;

            if (this.kelasku.length > 0 && !this.kelasku[0].is_sync) {
              this.t = setInterval(() => {
                clearInterval(this.t);
                this.getKelasku();
              }, 120000);
            }
          }
        })
        .catch(() => {
          this.t = setInterval(() => {
            clearInterval(this.t);
            this.getKelasku();
          }, 120000);
        });
    },
    // @vuese
    // tampilkan dialog pilih jadwal/mapel
    pilihJadwal(model, obj, showCourses, jenis) {
      return this.$refs.dlgKelas
        .open(model, obj, showCourses, jenis)
        .then(() => {
          this.getKelasku();
        })
        .catch(e => e);
    },
    // @vuese
    // tampilkan dialog pendaftaran tryout
    // @args mapel terpilih dan tahap yang diikuti sesuai index data
    pilihJadwalTryout(tahap) {
      return this.$refs.dlgTryout
        .open(this.mapelTerpilih, tahap)
        .then(() => {
          this.getKelasku();
        })
        .catch(e => e);
    },
    // @vuese
    // ubah pilihan mapel
    ubahMapel() {
      this.$confirm(
        `<div class="pt-2">Saat ini Anda sudah memilih ${this.mapelTerpilih.nama} sebagai mata pelajaran yang digunakan dalam program Guru Belajar dan Berbagi Seri ${
          this.current_instansi.nama
        }<br/><br/>
        <span class="error--text pb-3">Anda hanya dapat mengubah pilihan Mata Pelajaran sebanyak 1x.</span><br/><br/> Tekan Ya jika ingin ubah mata pelajaran<div>`
      ).then(() => {
        return this.$refs.dlgKelas
          .open("ubah")
          .then(() => this.getKelasku())
          .then(() => {
            return this.$store.dispatch("user/fetch", "reload").catch(e => e);
          })
          .catch(e => e);
      });
    },
    //@vuese
    // dialog ajuan pendaftaran tryout
    daftarTryout() {
      return this.$refs.dlgAjuan
        .open(this.tahapTryout)
        .then(() => {
          this.getKelasku();
        })
        .catch(e => e);
    },
    //@vuese
    // info perawatan kelas
    infoPerawatan() {
      return this.$refs.dlgPerawatan
        .open()
        .then(() => {
          this.getKelasku();
        })
        .catch(e => e);
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>
<style>
.transparent {
  background-color: transparent !important;
  border-color: transparent !important;
}
.flex {
  display: flex; /*Deklarasi display flex + antek2nya*/
  -moz-display: flex;
  -webkit-display: flex;
  -khtml-display: flex;
  -o-display: flex;
  justify-content: space-between;
}
</style>
